import { compose } from 'recompose';
import withBranchKey from '../hoc/withBranchKey';
import preventRenderForEmbeddedMode from
  '../../../../hoc/preventRenderForEmbeddedMode';
import preventRenderForKioskMode from
  '../../../../hoc/preventRenderForKioskMode';

const BranchContainer = compose(
  preventRenderForKioskMode,
  preventRenderForEmbeddedMode,
  withBranchKey,
);

export default BranchContainer;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/containers/Branch.js